import React from "react";
import { node, string, bool } from "prop-types";
import cx from "classnames";

const propTypes = {
  children: node,
  className: string,
  backgroundColor: string,
  backgroundImage: string,
  darkMode: bool,
  overlay: string,
};

const ContainerBleed = props => {
  const {
    children,
    className,
    backgroundColor,
    backgroundImage,
    darkMode,
    overlay,
    ...otherProps
  } = props;

  const backgroundStyle = backgroundColor
    ? { "--c-background": backgroundColor }
    : null;

  const backgroundImageStyle = backgroundImage
    ? { backgroundImage: `url(${backgroundImage})` }
    : null;

  const inlineStyle = Object.assign({}, backgroundStyle, backgroundImageStyle);

  return (
    <section
      {...otherProps}
      className={cx("container", "container--bleed", className, {
        "has-background": backgroundColor || backgroundImage,
        "is-dark-mode": darkMode,
      })}
      style={inlineStyle}
    >
      {overlay && (
        <div className="container--overlay" style={{ background: overlay }} />
      )}
      {children}
    </section>
  );
};

ContainerBleed.propTypes = propTypes;
export default ContainerBleed;
